// extracted by mini-css-extract-plugin
export default {"content":"WelcomeDialogNew__content--28YJt","title":"WelcomeDialogNew__title--16aeB","text":"WelcomeDialogNew__text--1Dy0A","footerText":"WelcomeDialogNew__footerText--2x_ti"};